import styled from "styled-components";

export const StyledHistoryCourseModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 420px;
  box-sizing: border-box;

  & .input-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    gap: 20px;

    & .mb {
      margin-bottom: 20px;
    }

    & div {
      max-width: 265px;
    }
  }
`;
